import _RARService from './_RARService'
//import _LibArchiveService from './_LibArchiveService'

import _ZIPService from './_ZIPService'
import _7ZService from './_7ZService'
import { gaEvent } from './Utils'
//import { file } from 'jszip';

export default class ExtractService {
    service = null;
    archiveFile = null;
    filter = null;
    ext = null;
    fallback = false;

    constructor(archiveFile, filter) {
        this.ext = archiveFile.name.split('.').pop().toLowerCase();
        
        // TODO: Maybe actually analyze file instead of just using the extension?
        // e.g. bitjs has code for idetifying file type/signature https://github.com/codedread/bitjs                
        if (this.ext === 'zip') {                     
            this.archiveFile = archiveFile; // TODO: temp solution while figure out whats going wrong...
            this.filter = filter;            
            this.service = new _ZIPService(archiveFile, filter);
         } else if (this.ext === 'rar' || this.ext === 'cbr') {
            this.archiveFile = archiveFile;
            this.filter = filter;
             this.service = new _RARService(archiveFile, filter); 
            //this.service = new _LibArchiveService(archiveFile, filter); 
        } else {
            this.service = new _7ZService(archiveFile, filter);
        }                
    }
    
    getUnfilteredCount() {
        return this.service.getUnfilteredCount();
    }

    async getFileList(reset) {
        try {
            let result =  await this.service.getFileList(reset);            
            return result;
        } catch (e) {
            if (this.ext == 'rar') {
                console.log('RAR file was encrpyed')
                if (e.message && e.message.indexOf('RAR file was encrypted') > 0) {
                    console.log('lets try again')
                    let result =  await this.service.getFileList(true);
                    return result;
                }
            }
            if (e == 'Mac compressed') {                
                let result =  await this.service.getFileList(true, true);            
                return result;
            } else if(this.ext == 'zip' || this.ext == 'rar' || this.ext == 'cbr') {                
                
                if (!this.fallback) { // Dont know why, but kept running in a loop? Only try once. According GA anyyway... 
                    console.log('extract-service-error-exception', e);
                    gaEvent('extract-service-error-exception', JSON.stringify(e.message));
                    this.fallback = true;
                    if (e.message && e.message.indexOf('requested file could not be read, typically due to permission problems') > 0) {
                        throw e; // TODO: Figure out why its doing that... (because file is too large the to buffer stuff doesnt work)
                    } else {
                        //this.service = new _LibArchiveService(this.archiveFile, this.filter); // Lets fallback to libarchive...                    
                        console.log('Using fallback service...');
                        this.service = new _7ZService(this.archiveFile, this.filter); 
                        return this.service.getFileList();
                    }                    
                } else {
                    gaEvent('extract-service-ignore-error', JSON.stringify(e.message));
                    throw e;
                }
                
            } else {
                throw e;
            }
        }
    }


    async extractFile(filename) {             
        let file = await this.service.extractFile(filename);
        return file;                    
    }

    isEncrypted() {
        return this.service.isEncrypted();
    }

    async setPassword(password) {                
        return this.service.setPassword(password);
    }

    async saveFile(name) {
        return this.service.saveFile(name);
    }

    async saveAll(dirHandle, progressUpdateFn) {
        return this.service.saveAll(dirHandle, progressUpdateFn);
    }
    saveFileToDropbox(filename) {
        return this.service.saveFileToDropbox(filename);
    }
    saveAllToDropbox(progressUpdateFn) {
        return this.service.saveAllToDropbox(progressUpdateFn);
    }
}